import { JsonTxnBuilder, TxnSerializer } from './builders';
import { TxnComposeAction, TxnMergeAction } from './actions';

class TransactionManager {
  buildJSONTransaction(type, slice, attrs) {
    return JsonTxnBuilder.build(type, slice, attrs);
  }

  toDBJson(txns) {
    return TxnSerializer.toDBFormat(txns);
  }

  toRemirrorJson(txns) {
    return TxnSerializer.toRemirrorFormat(txns);
  }

  async processTransactionInBatches(txns) {
    const mergeAction = new TxnMergeAction();
    const composeAction = new TxnComposeAction();
    // const output = composeAction.performAction(mergeAction.performAction(txns));
    const output = mergeAction.performAction(txns);
    return output;
  }
}

const transactionManager = new TransactionManager();

export { transactionManager };
